import { Link } from "react-router-dom";
import { packagesInfo } from "../../utils/packagesInfo";

function Packages() {
  return (
    <section className={`w-full flex flex-col justify-center py-10`}>
      {/* Absolute Background */}
      {/* <img
        className={`absolute left-0 top-0 max-xl:hidden`}
        src="/img/home/Rectangle 14.png"
        alt="Absolute bg"
      /> */}
      <div
        className={`myContainer w-full flex flex-col justify-center gap-5 md:gap-20`}
      >
        <span className={`text-black text-2xl lg:text-4xl font-bold`}>
          پکیج های اشتراک سازمانی
        </span>
        <div
          className={`w-full flex flex-wrap max-2xl:justify-center items-center max-w-[1440px] mx-auto xl:px-20 gap-9`}
        >
          {packagesInfo?.map((itm, i) => (
            <div
              key={i}
              className={`w-full max-2xl:max-w-[402px] 2xl:w-[calc(33.33%-24px)] max-md:max-w-[300px] rounded-[20px] flex flex-col items-center gap-8 justify-between py-6 md:py-12 md:px-[70px] relative overflow-hidden`}
              style={{ backgroundColor: itm.bgColor }}
            >
              {/* Absolute Svg */}
              {itm.absIcon}

              <div
                className={`max-2xl:hidden absolute top-6 -left-14 -rotate-45 w-1/2 h-12 flex items-center justify-center`}
                style={{ backgroundColor: itm.bannerColor }}
              >
                <span className={`text-white font-semibold`}>
                  {itm?.title?.includes("آزمایشی")
                    ? "اشتراک ۷ روز"
                    : "اشتراک ۱ سال"}
                </span>
              </div>

              <span className={`text-black text-2xl font-black z-10`}>
                {itm?.title}
              </span>
              {itm?.icon}
              <div className={`flex flex-col gap-2 items-center`}>
                {itm?.specs?.map((jtm, j) => (
                  <span
                    key={j}
                    className="text-black font-semibold whitespace-nowrap"
                  >
                    {jtm}
                  </span>
                ))}
                <span className={`text-black font-semibold 2xl:hidden`}>
                  {itm?.title?.includes("آزمایشی")
                    ? "اشتراک ۷ روز"
                    : "اشتراک ۱ سال"}
                </span>
                <span className="text-black font-black">
                  قیمت: {itm?.price === 0 ? "رایگان" : itm?.price}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div
          className={`w-full flex items-center justify-center max-xl:hidden`}
        >
          <Link className={`w-full md:w-[190px]`} to={"/"}>
            <button className="btn bg-myBlue text-white">
              بازگشت به صفحه اصلی
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Packages;
